import { render, staticRenderFns } from "./DirectContactModal.vue?vue&type=template&id=2c114df4&scoped=true&"
import script from "./DirectContactModal.vue?vue&type=script&lang=js&"
export * from "./DirectContactModal.vue?vue&type=script&lang=js&"
import style0 from "./DirectContactModal.vue?vue&type=style&index=0&id=2c114df4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c114df4",
  null
  
)

export default component.exports